<!-- =========================================================================================
  File Name: DashboardSharelink.vue
  Description: Dashboard Analytics
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <!-- 链接 -->
    <div class="vx-row">
      <div class="vx-col w-full  mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <h1 class="mb-6 text-white">Congratulations {{userName}},</h1>
          <p class="xl:w-3/4 lg:w-4/5 font-semibold  md:w-2/3 w-4/5 mx-auto text-white"  style="background-color: #1d5791;font-size: 16px;padding: 6px 0;border-radius: 15px;">
            <span style="font-size: 18px;">Affiliate Link :</span>  &nbsp;&nbsp; 
            <span id="signUrlId">{{signupUrl}}</span> &nbsp;&nbsp; 
            <i class="el-icon-document-copy" style="cursor: pointer;" @click="copy"></i>
          </p>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Merchant List">
          <!-- table -->
          <el-table 
              v-loading="loading"
              :data="tableData.list" 
              max-height="580" 
              tooltip-effect="dark"
              empty-text="No Data"
              >
              <el-table-column prop="merchantEmail" label="merchantEmail">
                <template slot="header" slot-scope="scope">
                  <span>Merchant Email</span>
                </template>
              </el-table-column>
              <el-table-column prop="merchantName" label="merchantName">
                <template slot="header" slot-scope="scope">
                  <span>Merchant Name</span>
                </template>
              </el-table-column>
              <el-table-column prop="merchantRegisterTime" label="merchantRegisterTime">
                <template slot="header" slot-scope="scope">
                  <span>Merchant Register Time</span>
                </template>
              </el-table-column>
          </el-table>
          <div class=" pb-4"></div>
          <!-- pagination -->
          <div class="text-right">
              <el-pagination
                  v-if="+tableData.total>0"
                  :page-size="page.size"
                  layout="total, prev, pager, next"
                  @current-change="pageChange"
                  :total="+tableData.total">
              </el-pagination>
          </div>
        </vx-card>
      </div>
    </div>

    

  </div>
</template>

<script>

export default {
    data() {
        return {
          signupUrl: '',
          // theadList:['merchantEmail','merchantName','merchantRegisterTime'],
          tableData: [],
          page:{
              current: 1,
              size: 8
          },
          loading: true
        }
    },
    computed:{
      userName(){
        return localStorage.getItem('userName')
      },
      userId(){
        return localStorage.getItem('userId')
      }
    },
    components: {
    },
    methods: {
      pageChange(curr){
        this.page.current = curr
        this.searchInit()
      },
      searchInit(){
        const thisIns = this;
        const userId = this.userId
        this.loading = true;
        // 列表数据
        this.$http({
          method: 'get',
          url: `https://signup.dropshipchinapro.com/api/userMerchant/page/${userId}`,
          headers:{token: localStorage.getItem('token'), 'Content-Type': 'application/json;charset=UTF-8'},
          params: {
            current: thisIns.page.current,
            size: thisIns.page.size
          }
        }).then(function (res) {
          if(res.data.code !== 200){
              payload.notify({
                title: 'Error',
                text: res.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
              thisIns.loading = false
            } else {
              thisIns.tableData = res.data.data
              thisIns.loading = false
            }
          })
          .catch(function (error) {
            thisIns.loading = false
            thisIns.$vs.notify({
              title:'Error',
              text: error,
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'})
          });
      },
      // 复制
      copy(){
        var textarea = document.createElement('textarea')
        textarea.value = this.signupUrl;
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        // this.$vs.notify({
        //       title:'Success',
        //       text: 'copy success',
        //       color:'success',
        //       iconPack: 'feather'})
      },
    },
    created() {
      const thisIns = this;
      const userId = this.userId
      // 分享链接请求
      this.$http({
        method: 'get',
        url: `https://signup.dropshipchinapro.com/api/admin/signupUrl/${userId}`,
        headers:{token: localStorage.getItem('token'), 'Content-Type': 'application/json;charset=UTF-8'},
      }).then(function (res) {
          if(res.data.code !== 200){
              payload.notify({
                title: 'Error',
                text: res.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            } else {
              thisIns.signupUrl = res.data.data.signupUrl
            }
        })
        .catch(function (error) {
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        });
        this.searchInit()
    }
}
</script>

<style lang="scss" scoped>
#dashboard-analytics {
  /deep/ .el-pager li.active{
    color: #ffb808;
  }
  /deep/ .el-pager li:hover{
    color: #ffb808;
  }
  /deep/.el-loading-spinner .path{
    stroke: #ffb808;
  }
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
